import BaselineGrid from './grid';
import BaselineChart from './chart';
import constants from '$$helpers/constants';

class Baselines {
  #instance = null;

  init(instance) {
    this.#instance = instance;

    if (instance.config.multiview) {
      return;
    }

    BaselineChart.init(instance); // Includes logic of building/removing baselines
    BaselineGrid.init(instance); // This works like a cache/shore for baseline tasks
  }

  clearInstance() {
    this.#instance = null;
  }

  buildBaseline(baseline) {
    if (!this.#instance || this.#instance.$destroyed) {
      return;
    }

    if (!this.#instance.config.multiview && (this.#instance.ganttDataApi.isBase() || this.#instance.ganttDataApi.isExport() || this.#instance.ganttDataApi.isLink())) {
      return BaselineChart.buildBaseline(baseline);
    }
  }

  removeBaseline(baselineId) {
    BaselineGrid.clearBaselineTasksCache();
    BaselineChart.removeBaseline(baselineId);
  }

  async checkUserEnabledBaselines() {
    if (!this.#instance || this.#instance.$destroyed || this.#instance.config.multiview) {
      return;
    }
   
    const userEnabledBaselines = this.#instance.ganttDataApi.getUserActivitySettings(constants.USER_ACTIVITIES.BASELINES);

    if (!userEnabledBaselines) return;

    const currentProjectEnabledBaseline = userEnabledBaselines[this.#instance.config.gantt_id];

    if (!currentProjectEnabledBaseline) return;

    await this.buildBaseline(currentProjectEnabledBaseline);
  }
}

export default new Baselines();
